module.exports = __webpack_public_path__ + "img/slots.e6610e6f.png";